import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { appRolleVon, hatRecht, type AppRolle, type Recht } from './index';

export interface Berechtigung {
  /** `darf('erp.ausstellen')` -> true, wenn die angemeldete Person das Recht hat. */
  darf: (recht: Recht) => boolean;
  appRolle: AppRolle;
  /** Keycloak-Betrieb: Rollen und Passwoerter werden dort gepflegt, nicht hier. */
  ssoEnabled: boolean;
}

/**
 * Rechte der angemeldeten Person fuer Seiten und Knoepfe
 * (Verbesserungsplan, Paket 2). Regel: Knoepfe ohne Recht werden nicht
 * gerendert, nicht ausgegraut.
 */
export function useBerechtigung(): Berechtigung {
  const { user, ssoEnabled } = useAuth();
  const darf = useCallback((recht: Recht) => hatRecht(user, recht), [user]);
  return { darf, appRolle: appRolleVon(user), ssoEnabled };
}

export default useBerechtigung;
